:host{background:#fdfdfd}
/*# sourceMappingURL=main-point-cloud-toolbar.component.css.map */
